<title>{{ iagPortalFaqsPage.htmlTitle }}</title>
<div class="container">
  <a [href]="BackLinkURL"><i [ngClass]="BackLinkIcon"></i>{{ BackLinkTitle }}</a>
  <app-border-section [param]="param" [sections]="iagPortalFaqsPage.sections"></app-border-section>
</div>
